import validator from "validator";

const validateForm = (formData) => {
  const errors = {};

  if (validator.isEmpty(String(formData.name || "").trim())) {
    errors.name = "Name is required";
  }

  if (validator.isEmpty(String(formData.subject || ""))) {
    errors.subject = "Subject is required";
  }

  const phone = String(formData.phoneNumber || "");

  if (validator.isEmpty(phone)) {
    errors.phoneNumber = "Phone number is required";
  } else if (!validator.isNumeric(phone, { no_symbols: true })) {
    errors.phoneNumber = "Phone number must contain only digits";
  } else if (!validator.isLength(phone, { min: 4, max: 15 })) {
    errors.phoneNumber = "Phone number must be between 10 and 15 digits";
  }

  const email = String(formData.email || "");

  if (validator.isEmpty(email)) {
    errors.email = "Email is required";
  } else if (!validator.isEmail(email)) {
    errors.email = "Email is invalid";
  }

  if (validator.isEmpty(String(formData.issueType || ""))) {
    errors.issueType = "Issue Type is required";
  }

  if (
    formData.issueType === "Other" &&
    validator.isEmpty(String(formData.otherIssue || ""))
  ) {
    errors.otherIssue = "Please specify the issue";
  }

  if (validator.isEmpty(String(formData.priorityLevel || ""))) {
    errors.priorityLevel = "Priority Level is required";
  }

  if (validator.isEmpty(String(formData.description || ""))) {
    errors.description = "Description is required";
  }

  return errors;
};

export default validateForm;
